import request from '@/utils/request'
import Resource from '@/api/resource'

class UserResource extends Resource {
  constructor() {
    super('api/v1/users')
  }

  updateSelf(data) {
    return request({
      url: '/' + this.uri + '/self',
      method: 'put',
      data: data
    })
  }
  permissions(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/permissions',
      method: 'get'
    })
  }

  updatePermission(id, permissions) {
    return request({
      url: '/' + this.uri + '/' + id + '/permissions',
      method: 'put',
      data: permissions
    })
  }

  roleOptions() {
    return request({
      url: '/' + this.uri + '/role/options',
      method: 'get'
    })
  }

  countryOptions() {
    return request({
      url: '/' + this.uri + '/country/options',
      method: 'get'
    })
  }

  register(resource) {
    return request({
      url: '/' + this.uri + '/register/student/one',
      method: 'post',
      data: resource
    })
  }

  studentLists(query) {
    return request({
      url: '/' + this.uri + '/student/lists',
      method: 'get',
      params: query
    })
  }

  updateStudent(id, data) {
    return request({
      url: '/' + this.uri + '/student/' + id,
      method: 'put',
      data: data
    })
  }

  removeStudent(id) {
    return request({
      url: '/' + this.uri + '/student/' + id,
      method: 'delete'
    })
  }

  teacherLists(query) {
    return request({
      url: '/' + this.uri + '/teacher/lists',
      method: 'get',
      params: query
    })
  }

  createTeacher(resource) {
    return request({
      url: '/' + this.uri + '/teacher/one',
      method: 'post',
      data: resource
    })
  }

  updateTeacher(id, data) {
    return request({
      url: '/' + this.uri + '/teacher/' + id,
      method: 'put',
      data: data
    })
  }

  removeTeacher(id) {
    return request({
      url: '/' + this.uri + '/teacher/' + id,
      method: 'delete'
    })
  }

  zoomLists() {
    return request({
      url: '/' + this.uri + '/zoom/lists',
      method: 'get'
    })
  }

  updateZoom(data) {
    return request({
      url: '/' + this.uri + '/zoom/all',
      method: 'post',
      data: data
    })
  }
}

export { UserResource as default }
